import React from 'react'
import { Box, useColorModeValue } from '@chakra-ui/react'

export default function AuthCard({ children, ...props }) {
  const bg = useColorModeValue('bg.subtle', 'rgba(255,255,255,0.03)')
  return (
    <Box w="100%" p={5} borderRadius="md" bg={bg} borderWidth="1px" borderColor="border.subtle" {...props}>
      {children}
    </Box>
  )
}
